export default __webpack_public_path__ + "static/media/liberation.3bd90403.png";